import { CALENDAR_STATUS_META, isSameDay, type DayInfo } from "@/pages/admin/calendar/calendarUtils";

interface MonthViewProps {
  days: DayInfo[];
  cursor: Date;
  selectedIso: string | null;
  onSelect: (iso: string) => void;
}

const WEEK_HEADS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export default function MonthView({ days, cursor, selectedIso, onSelect }: MonthViewProps) {
  const now = new Date();

  return (
    <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
      <div className="grid grid-cols-7 border-b border-background-200">
        {WEEK_HEADS.map((head) => (
          <div
            key={head}
            className="px-2 py-3 text-center text-[11px] font-semibold uppercase tracking-wider text-foreground-500"
          >
            {head}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-7">
        {days.map((day) => {
          const inMonth = day.date.getMonth() === cursor.getMonth();
          const meta = CALENDAR_STATUS_META[day.status];
          const selected = day.iso === selectedIso;
          const isToday = isSameDay(day.date, now);
          return (
            <button
              key={day.iso}
              type="button"
              onClick={() => onSelect(day.iso)}
              className={`relative text-left min-h-[96px] p-2 border-b border-r border-background-200 transition-colors cursor-pointer ${
                day.status === "available" ? "bg-background-50 hover:bg-background-100" : meta.cell
              } ${selected ? "ring-2 ring-inset ring-primary-500" : ""} ${inMonth ? "" : "opacity-40"}`}
            >
              <span
                className={`inline-flex items-center justify-center w-7 h-7 rounded-full text-xs font-semibold ${
                  isToday ? "bg-primary-500 text-background-50" : "text-foreground-800"
                }`}
              >
                {day.date.getDate()}
              </span>

              <div className="mt-1.5 space-y-1">
                {day.bookings.length > 0 ? (
                  <span
                    className={`inline-flex items-center gap-1 text-[10px] font-semibold px-1.5 py-0.5 rounded-full border ${meta.chip}`}
                  >
                    <i className="ri-calendar-check-line"></i>
                    {day.bookings.length}
                  </span>
                ) : null}
                {day.blocks.length > 0 ? (
                  <span className="flex items-center gap-1 text-[10px] font-semibold text-foreground-600">
                    <i className="ri-lock-line"></i>
                    {meta.label}
                  </span>
                ) : null}
                {day.bookings.length === 0 && day.blocks.length === 0 && inMonth ? (
                  <span className="block text-[10px] text-foreground-400">Available</span>
                ) : null}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}